import { useGetDevicesNameQuery } from "../SearchFilters/searchFiltersSlice";

const ToastHeader = ({ dismiss }) => (
  <div className="flex items-center" style={{ marginBottom: "1rem" }}>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M13 13h-2V7h2m0 10h-2v-2h2M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2Z"
      />
    </svg>
    <div style={{ fontSize: "1.25rem", fontWeight: "600", flex: "1", marginLeft: "0.25rem" }}>New Alarm</div>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 512 512"
      onClick={dismiss}
      className="cursor-pointer"
    >
      <path
        fill="currentColor"
        d="M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208s208-93.31 208-208S370.69 48 256 48Zm75.31 260.69a16 16 0 1 1-22.62 22.62L256 278.63l-52.69 52.68a16 16 0 0 1-22.62-22.62L233.37 256l-52.68-52.69a16 16 0 0 1 22.62-22.62L256 233.37l52.69-52.68a16 16 0 0 1 22.62 22.62L278.63 256Z"
      />
    </svg>
  </div>
);
const AlarmDescription = ({ type, value }) => {
  return (
    <div className="flex">
      <div style={{ flex: "1", fontWeight: "550" }}>{type}</div>
      <div>:</div>
      <div style={{ flex: "1", marginLeft: "0.5rem" }}>{value}</div>
    </div>
  );
};
const NewAlarmToast = ({ alarmInfo, dismiss }) => {
  const { data: deviceNamesList = [] } = useGetDevicesNameQuery({});

  const customerName = alarmInfo.customer.station;
  const deviceName = deviceNamesList.find((device) => device.id === alarmInfo.device_id) ?? "-";

  return (
    <div style={{ minWidth: "18rem" }}>
      <ToastHeader dismiss={dismiss} />
      <div className="flex flex-col gap-1">
        <AlarmDescription type="Type" value={alarmInfo.type} />
        <AlarmDescription type="Station" value={customerName} />
        <AlarmDescription type="Asset Name" value={deviceName.value} />
      </div>
    </div>
  );
};

export default NewAlarmToast;
